/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { MultipleSelect, SelectButton } from "@nordcloud/gnui";
import { Level } from "~/views/globalSettings/types";
import { ServiceLevel } from "./types";

type ServiceLevelSwitchProps = {
  setServiceLevelId: (i: string) => void;
  name: string;
  serviceLevels: ServiceLevel[];
  setType: (i: string) => void;
  type: string;
};

function ServiceLevelSwitch({
  setServiceLevelId,
  serviceLevels,
  setType,
  type,
  name,
}: ServiceLevelSwitchProps) {
  React.useEffect(() => {
    name && setType(name);
  }, [name, setType]);

  return (
    <MultipleSelect size="small">
      {serviceLevels?.map((level: Level) => {
        return (
          <SelectButton
            key={level.index}
            name={level.name}
            value={level.id}
            labelText={level.name}
            onClick={() => {
              setType(level.name);
              setServiceLevelId(level.id);
            }}
            isActive={type === level.name}
          />
        );
      })}
    </MultipleSelect>
  );
}

export { ServiceLevelSwitch };
